var _g, _g2, _g3, _g4, _g5, _g6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g7, _g8, _g9, _mask, _g10, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 588,
    viewBox: "0 0 286 588",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.982,
    cy: 572.955,
    rx: 124.212,
    ry: 4.04494,
    fill: "black",
    fillOpacity: 0.01
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.949,
    cy: 572.647,
    rx: 120.072,
    ry: 3.23595,
    fill: "black",
    fillOpacity: 0.01
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.148,
    cy: 572.261,
    rx: 111.791,
    ry: 1.61798,
    fill: "black",
    fillOpacity: 0.01
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8932 0.952148H234.071C269.092 0.952148 284.198 18.2666 284.198 51.0788V522.755C284.198 554.463 267.988 572.881 234.071 572.881H51.8932C16.8728 572.881 1.7666 555.567 1.7666 522.755V51.0788C1.7666 18.2666 16.8728 0.952148 51.8932 0.952148Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8935 2.27734C18.4355 2.27734 3.0918 18.1405 3.0918 51.079V522.755C3.0918 555.693 18.4355 571.557 51.8935 571.557H234.072C266.439 571.557 282.873 554.575 282.873 522.755V51.079C282.873 18.1405 267.53 2.27734 234.072 2.27734H51.8935Z",
    fill: "#C9C6C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8935 2.27734C18.4355 2.27734 3.0918 18.1405 3.0918 51.079V522.755C3.0918 555.693 18.4355 571.557 51.8935 571.557H234.072C266.439 571.557 282.873 554.575 282.873 522.755V51.079C282.873 18.1405 267.53 2.27734 234.072 2.27734H51.8935Z",
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.02488 37.1347C7.80744 15.0935 23.1798 5.14648 51.8929 5.14648H234.071C262.783 5.14648 278.155 15.0924 281.939 37.131C276.56 17.4129 261.362 7.13351 234.071 7.13351H51.8931C24.6005 7.13351 9.40306 17.4141 4.02488 37.1347ZM3.83667 535.544C7.27269 558.394 22.6765 568.684 51.8929 568.684H234.071C262.705 568.684 278.87 557.256 282.218 534.34C276.959 554.765 261.165 566.255 234.071 566.255H51.8931C24.2751 566.255 9.04233 555.728 3.83667 535.544Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.02488 37.1347C7.80744 15.0935 23.1798 5.14648 51.8929 5.14648H234.071C262.783 5.14648 278.155 15.0924 281.939 37.131C276.56 17.4129 261.362 7.13351 234.071 7.13351H51.8931C24.6005 7.13351 9.40306 17.4141 4.02488 37.1347ZM3.83667 535.544C7.27269 558.394 22.6765 568.684 51.8929 568.684H234.071C262.705 568.684 278.87 557.256 282.218 534.34C276.959 554.765 261.165 566.255 234.071 566.255H51.8931C24.2751 566.255 9.04233 555.728 3.83667 535.544Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8935 7.13477H234.072C269.092 7.13477 284.198 24.0615 284.198 56.1389V517.252C284.198 548.25 267.988 566.256 234.072 566.256H51.8935C16.8731 566.256 1.76685 549.33 1.76685 517.252V56.1389C1.76685 24.0615 16.8731 7.13477 51.8935 7.13477Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8935 7.13477H234.072C269.092 7.13477 284.198 24.0615 284.198 56.1389V517.252C284.198 548.25 267.988 566.256 234.072 566.256H51.8935C16.8731 566.256 1.76685 549.33 1.76685 517.252V56.1389C1.76685 24.0615 16.8731 7.13477 51.8935 7.13477Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29388 51.0794C6.29388 35.3442 9.84986 23.9647 17.2858 16.5145C24.7217 9.06436 36.101 5.47967 51.8936 5.47967H234.072C249.865 5.47967 261.244 9.06436 268.68 16.5145C276.116 23.9647 279.672 35.3442 279.672 51.0794V522.755C279.672 537.926 275.846 549.31 268.268 556.904C260.69 564.497 249.306 568.355 234.072 568.355H51.8936C36.101 568.355 24.7217 564.771 17.2858 557.32C9.84986 549.87 6.29388 538.491 6.29388 522.755V51.0794Z",
    fill: "url(#paint5_linear)",
    stroke: "black",
    strokeWidth: 0.662466
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8933 7.79785H234.072C264.112 7.79785 277.132 20.8425 277.132 50.8582V522.534C277.132 551.443 263.01 565.594 234.072 565.594H51.8933C21.8526 565.594 8.83301 552.55 8.83301 522.534V50.8582C8.83301 20.8425 21.8526 7.79785 51.8933 7.79785Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8933 7.79785H234.072C264.112 7.79785 277.132 20.8425 277.132 50.8582V522.534C277.132 551.443 263.01 565.594 234.072 565.594H51.8933C21.8526 565.594 8.83301 552.55 8.83301 522.534V50.8582C8.83301 20.8425 21.8526 7.79785 51.8933 7.79785Z",
    fill: "url(#paint7_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8934 12.2139C24.3019 12.2139 13.2495 23.2711 13.2495 50.8577V522.534C13.2495 550.12 24.3019 561.178 51.8934 561.178H234.072C260.559 561.178 272.715 549.015 272.715 522.534V50.8577C272.715 23.2711 261.663 12.2139 234.072 12.2139H51.8934Z",
    fill: "black"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.947 571.999C136.909 571.999 149.225 571.999 155.237 571.999C155.289 571.999 155.34 571.999 155.39 572C156.851 572.012 156.708 572.882 155.247 572.882H130.937C129.476 572.882 129.333 572.012 130.794 572C130.845 571.999 130.896 571.999 130.947 571.999Z",
    fill: "#343434"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6948 11.6963C15.0169 17.5502 8.83289 30.1841 8.83289 50.8843V522.875C8.83289 542.342 15.2279 555.122 28.2298 561.399C28.2298 560.701 13.691 551.038 13.691 525.085C13.691 512.527 13.691 62.6751 13.691 48.6323C13.691 21.2547 28.6948 11.6963 28.6948 11.6963Z",
    fill: "white",
    fillOpacity: 0.599524
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.269 11.6963C270.947 17.5502 277.131 30.1841 277.131 50.8843V522.875C277.131 542.342 270.736 555.122 257.734 561.399C257.734 560.701 272.273 551.038 272.273 525.085C272.273 512.527 272.273 62.6751 272.273 48.6323C272.273 21.2547 257.269 11.6963 257.269 11.6963Z",
    fill: "white",
    fillOpacity: 0.599524
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.602808,
    x: 1.76709,
    y: 55.7158,
    width: 4.85809,
    height: 3.9748,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.602808,
    x: 279.34,
    y: 55.7158,
    width: 4.85809,
    height: 3.9748,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.602808,
    x: 225.46,
    y: 5.81055,
    width: 4.85809,
    height: 3.9748,
    transform: "rotate(-90 225.46 5.81055)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.602808,
    x: 56.531,
    y: 572.881,
    width: 4.85809,
    height: 3.9748,
    transform: "rotate(-90 56.531 572.881)",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.602808,
    x: 1.76709,
    y: 514.143,
    width: 4.85809,
    height: 3.9748,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.602808,
    x: 279.34,
    y: 514.143,
    width: 4.85809,
    height: 3.9748,
    fill: "black"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_ii)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.54156 78.2402C0.690179 78.2402 0 78.9323 0 79.786V98.7767C0 99.6304 0.690179 100.322 1.54156 100.322H2.42245C2.42245 99.161 2.43729 79.3756 2.42245 78.2402H1.54156Z",
    fill: "url(#paint8_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_ii)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.54156 118.651C1.04034 118.775 0.439316 119.091 0.11839 119.54C0.0522867 119.632 0 119.925 0 120.009C0 124.253 0 137.18 0 158.791C0 158.881 0.0735954 159.337 0.118657 159.447C0.37836 160.085 0.829598 160.239 1.54156 160.608H2.42245C2.42245 159.446 2.43729 119.787 2.42245 118.651H1.54156Z",
    fill: "url(#paint9_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_ii)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.54156 170.985C1.04034 171.109 0.439316 171.425 0.11839 171.874C0.0522867 171.966 0 172.259 0 172.343C0 176.587 0 189.514 0 211.125C0 211.215 0.0735954 211.671 0.118657 211.781C0.37836 212.419 0.829598 212.573 1.54156 212.942H2.42245C2.42245 211.78 2.43729 172.121 2.42245 170.985H1.54156Z",
    fill: "url(#paint10_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_ii)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.423 132.341C284.924 132.464 285.525 132.78 285.846 133.229C285.912 133.322 285.965 133.614 285.965 133.699C285.965 137.943 285.965 175.602 285.965 197.212C285.965 197.302 285.891 197.758 285.846 197.869C285.586 198.506 285.135 198.661 284.423 199.029H283.542C283.542 197.868 283.527 133.476 283.542 132.341H284.423Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.423 132.341C284.924 132.464 285.525 132.78 285.846 133.229C285.912 133.322 285.965 133.614 285.965 133.699C285.965 137.943 285.965 175.602 285.965 197.212C285.965 197.302 285.891 197.758 285.846 197.869C285.586 198.506 285.135 198.661 284.423 199.029H283.542C283.542 197.868 283.527 133.476 283.542 132.341H284.423Z",
    fill: "url(#paint12_linear)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.801364,
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.869,
    y: 21.4893,
    width: 34.4482,
    height: 4.63726,
    rx: 2.31863,
    fill: "#1D1C1C"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 21,
    width: 36,
    height: 6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.869,
    y: 21.4893,
    width: 34.4482,
    height: 4.63726,
    rx: 2.31863,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.869 21.4893H160.317V21.8047H125.869V21.4893ZM125.869 22.4353H160.317V22.7508H125.869V22.4353ZM160.317 23.3819H125.869V23.6973H160.317V23.3819ZM125.869 24.3284H160.317V24.6439H125.869V24.3284ZM160.317 25.2749H125.869V25.5904H160.317V25.2749Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.868 22.1514H160.317V22.4668H125.868V22.1514ZM125.868 23.0974H160.316V23.4128H125.868V23.0974ZM160.316 24.0439H125.868V24.3594H160.316V24.0439ZM125.868 24.9913H160.316V25.3068H125.868V24.9913ZM160.316 25.937H125.868V26.2525H160.316V25.937Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.343 21.1729H127.712V26.5357H127.343V21.1729ZM126.237 21.1731H126.606V26.5359H126.237V21.1731ZM128.817 21.1729H128.449V26.5357H128.817V21.1729ZM129.554 21.1729H129.923V26.5357H129.554V21.1729ZM131.028 21.1729H130.66V26.5357H131.028V21.1729ZM131.766 21.1729H132.134V26.5357H131.766V21.1729ZM133.24 21.1729H132.872V26.5357H133.24V21.1729ZM133.977 21.1729H134.346V26.5357H133.977V21.1729ZM135.452 21.1729H135.083V26.5357H135.452V21.1729ZM136.188 21.1729H136.557V26.5357H136.188V21.1729ZM137.663 21.1729H137.294V26.5357H137.663V21.1729ZM138.4 21.1729H138.769V26.5357H138.4V21.1729ZM139.875 21.1729H139.506V26.5357H139.875V21.1729ZM140.612 21.1729H140.98V26.5357H140.612V21.1729ZM142.086 21.1729H141.717V26.5357H142.086V21.1729ZM142.823 21.1729H143.191V26.5357H142.823V21.1729ZM144.297 21.1729H143.929V26.5357H144.297V21.1729ZM145.035 21.1729H145.403V26.5357H145.035V21.1729ZM146.509 21.1729H146.141V26.5357H146.509V21.1729ZM147.245 21.1729H147.614V26.5357H147.245V21.1729ZM148.72 21.1729H148.352V26.5357H148.72V21.1729ZM149.457 21.1729H149.826V26.5357H149.457V21.1729ZM150.932 21.1729H150.563V26.5357H150.932V21.1729ZM151.669 21.1729H152.038V26.5357H151.669V21.1729ZM153.143 21.1729H152.775V26.5357H153.143V21.1729ZM153.88 21.1729H154.249V26.5357H153.88V21.1729ZM155.355 21.1729H154.986V26.5357H155.355V21.1729ZM156.092 21.1729H156.46V26.5357H156.092V21.1729ZM157.566 21.1729H157.198V26.5357H157.566V21.1729ZM158.304 21.1729H158.672V26.5357H158.304V21.1729ZM159.778 21.1729H159.409V26.5357H159.778V21.1729Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.576 21.1719H125.945V26.5347H125.576V21.1719ZM126.681 21.1726H127.05V26.5354H126.681V21.1726ZM128.155 21.1726H127.787V26.5354H128.155V21.1726ZM128.893 21.1726H129.261V26.5354H128.893V21.1726ZM130.367 21.1726H129.999V26.5354H130.367V21.1726ZM131.104 21.1726H131.473V26.5354H131.104V21.1726ZM132.578 21.1726H132.21V26.5354H132.578V21.1726ZM133.315 21.1726H133.684V26.5354H133.315V21.1726ZM134.79 21.1726H134.421V26.5354H134.79V21.1726ZM135.527 21.1726H135.896V26.5354H135.527V21.1726ZM137.001 21.1726H136.633V26.5354H137.001V21.1726ZM137.739 21.1726H138.107V26.5354H137.739V21.1726ZM139.213 21.1726H138.844V26.5354H139.213V21.1726ZM139.95 21.1726H140.318V26.5354H139.95V21.1726ZM141.425 21.1726H141.056V26.5354H141.425V21.1726ZM142.162 21.1726H142.53V26.5354H142.162V21.1726ZM143.636 21.1726H143.267V26.5354H143.636V21.1726ZM144.373 21.1726H144.741V26.5354H144.373V21.1726ZM145.847 21.1726H145.479V26.5354H145.847V21.1726ZM146.584 21.1726H146.953V26.5354H146.584V21.1726ZM148.059 21.1726H147.69V26.5354H148.059V21.1726ZM148.796 21.1726H149.164V26.5354H148.796V21.1726ZM150.27 21.1726H149.902V26.5354H150.27V21.1726ZM151.008 21.1726H151.376V26.5354H151.008V21.1726ZM152.482 21.1726H152.113V26.5354H152.482V21.1726ZM153.219 21.1726H153.587V26.5354H153.219V21.1726ZM154.693 21.1726H154.324V26.5354H154.693V21.1726ZM155.43 21.1726H155.799V26.5354H155.43V21.1726ZM156.905 21.1726H156.536V26.5354H156.905V21.1726ZM157.642 21.1726H158.011V26.5354H157.642V21.1726ZM159.116 21.1726H158.748V26.5354H159.116V21.1726Z",
    fill: "white",
    fillOpacity: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.244441,
    filter: "url(#filter11_iii)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.869,
    y: 21.4893,
    width: 34.4482,
    height: 4.63726,
    rx: 2.31863,
    fill: "black",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 21,
    width: 36,
    height: 6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.869,
    y: 21.4893,
    width: 34.4482,
    height: 4.63726,
    rx: 2.31863,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 173.346,
    cy: 23.6966,
    r: 4.19562,
    fill: "url(#paint13_radial)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.387535,
    filter: "url(#filter12_dd)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 173.346,
    cy: 23.6965,
    r: 2.20822,
    fill: "url(#paint14_radial)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 171,
    y: 21,
    width: 5,
    height: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 173.346,
    cy: 23.6965,
    r: 2.20822,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.673,
    cy: 23.315,
    rx: 1.82466,
    ry: 0.611495,
    transform: "rotate(-76 171.673 23.315)",
    fill: "#3E89CC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.113,
    cy: 23.1444,
    rx: 1.32493,
    ry: 1.65617,
    fill: "#1C5894"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.811,
    cy: 25.4049,
    rx: 1.96489,
    ry: 1.28232,
    transform: "rotate(-16 173.811 25.4049)",
    fill: "#0A152B"
  }))))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 17,
    width: 250,
    height: 539
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.21 23.6884V23.9091C212.21 30.0443 207.527 37.8156 196.753 37.8156H89.4331C78.6583 37.8156 73.9755 30.0443 73.9755 23.9091V23.6884C73.9755 20.8508 73.9755 17.9492 68.8966 17.9492H47.4769C29.5759 17.9492 18.77 28.751 18.77 46.6451V526.97C18.77 544.864 29.5759 555.666 47.4769 555.666H238.488C256.389 555.666 267.195 544.864 267.195 526.97V46.6451C267.195 28.751 256.389 17.9492 238.488 17.9492H217.289C212.21 17.9492 212.21 20.8508 212.21 23.6884Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.77,
    y: 17.9492,
    width: 248.425,
    height: 537.717,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.77,
    y: 17.9492,
    width: 248.425,
    height: 537.923,
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 70,
    width: 248,
    height: 486,
    fill: "url(#pattern1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 8.83303,
    y: 559.525,
    width: 268.299,
    height: 27.9639,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.552055
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.9685
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 19.0123,
    y: 566.099,
    width: 247.873,
    height: 14.2007,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.552055
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.93219
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 28.5962,
    y: 568.434,
    width: 229.103,
    height: 8.7565,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.552055
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.38014
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i",
    x: 3.0918,
    y: 2.27734,
    width: 279.782,
    height: 569.279,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.828083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i",
    x: 129.767,
    y: 571.999,
    width: 26.65,
    height: 0.883288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.276028
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i",
    x: 8.83301,
    y: 11.6963,
    width: 22.0702,
    height: 549.703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.20822
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.93219
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i",
    x: 257.269,
    y: 11.6963,
    width: 22.0702,
    height: 549.703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.20822
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.93219
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_ii",
    x: 0,
    y: 77.6882,
    width: 2.42904,
    height: 23.1863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10411
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.276028
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.757614 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.10411
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.276028
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.757614 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_ii",
    x: 0,
    y: 118.099,
    width: 2.42904,
    height: 43.0603,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10411
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.276028
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.757614 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.10411
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.276028
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.757614 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_ii",
    x: 0,
    y: 170.433,
    width: 2.42904,
    height: 43.0603,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10411
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.276028
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.757614 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.10411
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.276028
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.757614 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_ii",
    x: 283.536,
    y: 131.789,
    width: 2.42904,
    height: 67.7924,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10411
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.276028
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.757614 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.10411
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.276028
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.757614 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_iii",
    x: 125.869,
    y: 21.4893,
    width: 34.4482,
    height: 4.63726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.10411,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552055
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.795035 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.10411
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.80013 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.552055
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.197067 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_dd",
    x: 168.93,
    y: 19.2801,
    width: 8.83288,
    height: 8.83288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.10411,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552055
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.552055,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f",
    x: 169.733,
    y: 20.3376,
    width: 3.88017,
    height: 5.95449,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.600257,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f",
    x: 172.587,
    y: 20.2878,
    width: 5.05089,
    height: 5.71336,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.600257,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f",
    x: 170.988,
    y: 23.1573,
    width: 5.64646,
    height: 4.49608,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.450662,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.00133333 0.000615764)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1",
    transform: "translate(-0.0537778 0.0220066) scale(0.0024705 0.0013089)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 3.0918,
    y1: 2.27734,
    x2: 3.0918,
    y2: 571.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C6C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0168336,
    stopColor: "#716D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0782507,
    stopColor: "#C9C6C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.920557,
    stopColor: "#C9C6C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980426,
    stopColor: "#716D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C6C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 134.114,
    y1: 5.14648,
    x2: 134.114,
    y2: 41.2319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.901495
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 152.866,
    y1: 568.684,
    x2: 152.866,
    y2: 528.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 133.94,
    y1: 7.13477,
    x2: 133.94,
    y2: 42.9374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 152.965,
    y1: 566.256,
    x2: 152.965,
    y2: 526.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 5.96265,
    y1: 5.14844,
    x2: 5.96265,
    y2: 568.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101238,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 8.83301,
    y1: 7.79785,
    x2: 8.83301,
    y2: 565.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984697
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C5C5C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(136.672 559.977) rotate(90) scale(161.518 56.7169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.151268
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 0.660251,
    y1: 91.2087,
    x2: 1.32793,
    y2: 91.2087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00734796,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994739,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 0.660251,
    y1: 143.291,
    x2: 1.32793,
    y2: 143.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00734796,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994739,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 0.660251,
    y1: 195.625,
    x2: 1.32793,
    y2: 195.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00734796,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994739,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 285.125,
    y1: 162.855,
    x2: 285.088,
    y2: 162.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBCBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 285.965,
    y1: 132.341,
    x2: 285.965,
    y2: 199.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.996971
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0951211,
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895463,
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.881058
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.308 30.7558) rotate(45.1938) scale(8.44674)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(173.346 21.4883) rotate(90) scale(4.41644)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A4893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213054"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 282.431,
    height: 571.929,
    fill: "white",
    transform: "translate(1.7666 0.952148)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.1233,
    height: 0.883288,
    fill: "white",
    transform: "translate(126.531 571.999)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 268.299,
    height: 549.847,
    fill: "white",
    transform: "translate(8.83276 11.5518)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 285.965,
    height: 134.701,
    fill: "white",
    transform: "translate(0 78.2402)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.4482,
    height: 4.63726,
    fill: "white",
    transform: "translate(125.869 21.4883)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.39124,
    height: 8.39124,
    fill: "white",
    transform: "translate(169.15 19.501)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f17fa2a3.svg";
export { ForwardRef as ReactComponent };